// src/services/coords.js
import proj4 from "proj4";

// ---- Define the CRSs we care about ----
// WGS84 is built-in as "EPSG:4326"
const defs = {
  "EPSG:2157":
    "+proj=tmerc +lat_0=53.5 +lon_0=-8 +k=0.99982 +x_0=600000 +y_0=750000 +ellps=GRS80 +units=m +no_defs",
  // OSGB36 / British National Grid (approx; without OSTN grid shifts)
  "EPSG:27700":
    "+proj=tmerc +lat_0=49 +lon_0=-2 +k=0.9996012717 +x_0=400000 +y_0=-100000 +ellps=airy +units=m +towgs84=446.448,125.157,542.06,0.1502,0.2470,0.8421,-20.4894 +no_defs",
};

let defsRegistered = false;
function ensureDefs() {
  if (defsRegistered) return;
  Object.entries(defs).forEach(([code, def]) => proj4.defs(code, def));
  defsRegistered = true;
}

export function toLatLng({ x, y }, fromEpsg = "EPSG:2157") {
  ensureDefs();
  if (fromEpsg === "EPSG:4326") {
    return { lat: y, lng: x };
  }
  const [lng, lat] = proj4(fromEpsg, "EPSG:4326", [x, y]);
  return { lat, lng };
}

export function toLocal({ lat, lng }, toEpsg = "EPSG:2157") {
  ensureDefs();
  if (toEpsg === "EPSG:4326") {
    return { x: lng, y: lat };
  }
  const [x, y] = proj4("EPSG:4326", toEpsg, [lng, lat]);
  return { x, y };
}

export function formatLocal({ x, y }, epsg) {
  const fixed = epsg === "EPSG:27700" || epsg === "EPSG:2157" ? 2 : 5;
  return `${x.toFixed(fixed)}, ${y.toFixed(fixed)}`;
}
